import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import {
  AttachmentsView,
  AttachmentsViewOptions
} from "core/classes/attachments/attachments.view.class";
import { SwiperClass } from "core/classes/swiper/swiper.class";
import { DataModel } from "core/classes/data.model.class";

let AttachmentsGalleryOptions = function() {
  return $.extend({}, AttachmentsViewOptions, {
    controlsHTML:
      "<div class='controls toolbar galleryControls'><ul><li class='previous'><a href='#' tabindex='0'>Previous slide</a></li><li class='next'><a href='#' tabindex='1'>Next slide</a></li></ul></div>",
    attachmentClasses: {
      gallery: ".gallery-attachments"
    },
    initialSlideTimeout: 2000,
    swiper: {
      noSwiping: true,
      roundLengths: true
    }
  });
};

class AttachmentsGallery extends AttachmentsView {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.mediator = $({});
    this.setOptions(AttachmentsGalleryOptions(), options);
    this.setupPreEvents();
    this.model = new DataModel(this.element).getModel();
    var swiperOptions = $.extend({}, this.options.swiper, {
      initialSlide: this.model.gallery.selected
    });
    this.swiper = new SwiperClass(this.element, this.mediator, {
      swiper: swiperOptions
    });
    this.setupGalleryHoverButtons();
    this.setupEvents();
    this.setupKeyEvents();

    this.slides = this.swiper.getSwiperSlides().length;
    this.checkButtons(this.swiper.swiper.activeIndex, this.slides);
  }

  setupPreEvents() {
    var self = this;

    this.mediator.on("swiperPreInit", function(evt, element, model) {
      var slides = $(element).find(".swiper-slide");
      self.addLoaders(self.options.loading.initalLoad);
    });

    this.mediator.on("swiperLoaded", function(evt, element) {
      self.swiper.preload();
      self.addMaxHeight();
      self.removeLoaders(self.options.loading.initalLoad);
      $(window).trigger("abacus:loadGallery:complete", self);
    });
  }

  setupEvents() {
    var self = this;
    $(window).resize(function() {
      self.addMaxHeight();
    });

    this.element
      .find(this.options.buttons.previous)
      .off()
      .on("click", function(evt) {
        evt.preventDefault();
        self.swiper.previous();
        self.checkButtons();
      });

    this.element
      .find(this.options.buttons.next)
      .off()
      .on("click", function(evt) {
        evt.preventDefault();
        self.swiper.next();
        self.checkButtons();
      });

    this.swiper.swiper.on("slideChangeTransitionStart", function() {
      self.addLoaders(self.options.loading.others);
    });

    this.swiper.swiper.on("slideChangeTransitionEnd", function() {
      // var index = swiper.activeIndex;
      var index = self.swiper.getActiveIndex();
      self.updateAdvert();
      self.createCaption(self.model.gallery.slides[index].caption);
      self.swiper.preload();
      self.updateCounter(index);
      self.checkButtons(index, self.slides);
      self.removeLoaders(self.options.loading.others);
    });
  }

  addMaxHeight() {
    var galleryImages = this.element.find(
      this.options.attachmentClasses.gallery
    );
    galleryImages.attr("tabindex", "2");
    galleryImages.find("img").css("max-height", galleryImages.height());
  }

  setupGalleryHoverButtons() {
    $(this.options.controlsHTML).appendTo(
      this.options.attachmentClasses.gallery
    );
  }
}

export { AttachmentsGallery, AttachmentsGalleryOptions };



// WEBPACK FOOTER //
// ./Javascript/core/classes/attachments/attachments.gallery.class.js